export default __webpack_public_path__ + "media/zurb/img/about/talent/talent-img2-8caf422f315d9c4b5a3111c052ed3425.png";